export enum DeviceType {
    VIRTUAL = 'VIRTUAL',
    REAL = 'REAL'
}
